import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a43eddc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "info" }

import { Icon } from '@iconify/vue';
import { useLanguageSwitcher } from '@/composables/useLanguageSwitcher';
import { useCursorHover } from '@/directives/useCursorHover';
import { useThemeStore } from '@/stores/theme';
import { DarkTheme, LightTheme } from '@/constants/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const { t } = useLanguageSwitcher();

const vCursorHover = useCursorHover();

const themeStore = useThemeStore();

const currentYear: number = new Date().getFullYear();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('author')) + " - " + _toDisplayString(_unref(currentYear)) + " " + _toDisplayString(_unref(t)('footer.allRightsReserved')), 1)
  ]))
}
}

})